import { ColumnPicker } from "./column-picker";
import type { ComparisonItem, VisibleColumn } from "./use-comparison-columns";

type ComparisonHeadProperties = {
  items: ComparisonItem[];
  labelColumnHeading: string;
  onColumnChange: (columnKey: number, itemId: string) => void;
  showColumnPickers: boolean;
  showLabelColumn: boolean;
  visibleColumns: VisibleColumn[];
};

export const ComparisonHead = ({
  items,
  labelColumnHeading,
  onColumnChange,
  showColumnPickers,
  showLabelColumn,
  visibleColumns,
}: ComparisonHeadProperties) => (
  <thead>
    <tr>
      {showLabelColumn && (
        <th scope="col">
          <span className="sr-only">{labelColumnHeading}</span>
        </th>
      )}

      {visibleColumns.map(({ columnKey, item }) => (
        <th className="px-1 align-top" key={columnKey} scope="col">
          {showColumnPickers ? (
            <ColumnPicker
              item={item}
              items={items}
              // Deliberately keyed by item.id (unlike the `<th>` above): we
              // *want* this to remount and reset its internal state
              // whenever the selected item for this column changes.
              key={item.id}
              onChange={(id) => {
                onColumnChange(columnKey, id);
              }}
            />
          ) : (
            item.title
          )}

          {item.headerContent && (
            <div
              className="
                my-3

                md:my-4
              "
            >
              {item.headerContent}
            </div>
          )}
        </th>
      ))}
    </tr>
  </thead>
);
